import { OverviewModel } from '../models/overview';

import BaseApiService from './base-api-service';

export default class OverviewService extends BaseApiService {
  public async getOverview(ac: AbortController): Promise<OverviewModel> {
    const response = await this.getResource('/GetOverview', ac);

    return response;
  }
}
